// Meal plan data adapters for Chef Lex v3.2 to Wasp integration

export type MealPlanStatus = 'completed' | 'in-progress' | 'archived';

export interface MealPlan {
  id: string;
  name: string;
  weekRange: string;
  createdAt: string;
  recipeCount: number;
  servings: number;
  avgCalories: number;
  status: MealPlanStatus;
  thumbnail: string;
}

export function toV32Status(s: string): MealPlanStatus {
  switch ((s ?? '').toLowerCase()) {
    case 'ready':
    case 'completed': 
      return 'completed';
    case 'generating':
    case 'in-progress': 
      return 'in-progress';
    case 'archived': 
      return 'archived';
    default: 
      return 'in-progress';
  }
}

export function toV32Plans(raw: any[]): MealPlan[] {
  return raw.map(p => {
    const created = p.createdAt || p.weekStartDate || new Date().toISOString()
    const days: any[] = Array.isArray(p?.planData?.days) ? p.planData.days : []
    const recipeCount = days.reduce((sum, d) => {
      const meals = d?.meals
      if (Array.isArray(meals)) return sum + meals.length
      return sum + Object.keys(meals || {}).length
    }, 0)
    const avgFromSummary = Number(p?.planData?.nutritionSummary?.averageCaloriesPerDay)
    const avgCalories = Number.isFinite(avgFromSummary) ? Math.round(avgFromSummary) : (p.avgCalories ?? 0)
    return {
      id: p.id,
      name: p.name ?? `Plan ${new Date(created).toLocaleDateString()}`,
      weekRange: formatWeekRange(p.weekStartDate || created),
      createdAt: created,
      recipeCount,
      servings: p.servings ?? 2,
      avgCalories,
      status: toV32Status(p.status ?? p.generationStatus),
      thumbnail: p.thumbnail ?? '🍽️'
    }
  });
}

function formatWeekRange(dateStr: string): string {
  const date = new Date(dateStr);
  const weekStart = new Date(date);
  weekStart.setDate(date.getDate() - date.getDay());
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekStart.getDate() + 6);
  
  return `${weekStart.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${weekEnd.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`;
}
